import { Injectable } from '@angular/core';
import { BackendEndpoints } from 'app/app-model/config/backend-endpoints.model';
import { API_ENDPOINTS } from 'app/app-model/constants/api-endpoints';
import { environment } from 'environments/environment';


@Injectable({ providedIn: 'root' })
export class ConfigService {
    private config: BackendEndpoints = API_ENDPOINTS['local-scania'];

    private resolveEndpointBrand(brand: string): string {
        if (environment.name.startsWith('us-')) {
            return 'international';
        }

        return (brand || environment.defaultBrand).toLowerCase();
    }

    get apiUrl(): string {
        return this.config.apiUrl;
    }

    /**
     * Base URL of the global dcode instance. Used by the "Import from global" feature to
     * gather source specification data, regardless of the current environment.
     */
    get globalApiUrl(): string {
        return environment.globalApiUrl;
    }

    get hubUrl(): string {
        return this.config.hubUrl;
    }

    get newUiUrl(): string {
        return this.config.newUiUrl;
    }

    setBrand(brand: string) {
        const apiEndPointSelector = `${environment.name}-${this.resolveEndpointBrand(brand)}`;
        const fallbackSelector = `${environment.name}-${this.resolveEndpointBrand(environment.defaultBrand)}`;

        this.config = API_ENDPOINTS[apiEndPointSelector] || API_ENDPOINTS[fallbackSelector];

        if (!this.config) {
            throw new Error(`Missing API endpoint configuration for selectors: ${apiEndPointSelector}, ${fallbackSelector}`);
        }
    }
    
}
